import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6729089e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bigbox" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "setting" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"fontsize":"24px"} }, "+ ", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 添加渠道 ")
const _hoisted_6 = { class: "tablebox" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "gray_type"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("确定")
const _hoisted_12 = { class: "pushTable" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 1,
  class: "gray_type"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Pageheader = _resolveComponent("Pageheader")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Publicform = _resolveComponent("Publicform")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_MyTable = _resolveComponent("MyTable")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Pageheader, {
      title: "渠道管理",
      img: "/compontsimg/icon_jsgl.png",
      text: "创建、管理平台分销（佣）渠道"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Publicform, {
          formList: _ctx.formList,
          onSubmitForm: _ctx.submitForm
        }, {
          from: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                color: "#FCA616",
                style: {"color":"#fff"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addDialog({}))),
                round: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_4,
                  _hoisted_5
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["formList", "onSubmitForm"]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_MyTable, {
            isLoading: _ctx.MyTable.tableloading,
            tableData: _ctx.MyTable.tableData,
            isPagination: true,
            isIndex: true,
            pageSize: _ctx.MyTable.selectData.pageSize,
            total: _ctx.MyTable.TotalPageTable,
            currentPage: _ctx.MyTable.selectData.pageNum,
            tableColumn: _ctx.MyTable.tableColumn,
            onHandleCurrentChange: _ctx.handleMyTable
          }, {
            merchantNum: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "分销商户",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  (row.merchantNum > 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.seeTable.seeDialog(row)),
                        class: "blue_type"
                      }, _toDisplayString(row.merchantNum), 9, _hoisted_7))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(row.merchantNum), 1))
                ]),
                _: 1
              })
            ]),
            slotName: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "操作",
                width: "170"
              }, {
                default: _withCtx(({ row }) => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    style: {"color":"#fff"},
                    onClick: ($event: any) => (_ctx.addDialog(row)),
                    round: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["isLoading", "tableData", "pageSize", "total", "currentPage", "tableColumn", "onHandleCurrentChange"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.addChannel,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.addChannel) = $event)),
      title: _ctx.dialogTit,
      width: "512px",
      "destroy-on-close": ""
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addChannel = false))
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addSubmit(_ctx.addFormRef)))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "addFormRef",
          model: _ctx.addForm,
          rules: _ctx.rules,
          "label-width": "92px",
          class: "demo-ruleForm",
          size: _ctx.formSize,
          "status-icon": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "渠道名称",
              prop: "channelName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.addForm.channelName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.addForm.channelName) = $event)),
                  placeholder: "请输入权益名称，最多20个字"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "负责人",
              prop: "channelContactName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.addForm.channelContactName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.addForm.channelContactName) = $event)),
                  placeholder: "请输入负责人名字"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "联系电话",
              prop: "channelMobile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.addForm.channelMobile,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.addForm.channelMobile) = $event)),
                  placeholder: "请输入联系电话"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "size"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.seeTable.seeChannel,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.seeTable.seeChannel) = $event)),
      title: "查看分销商户",
      width: "938px",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_MyTable, {
            isLoading: _ctx.seeTable.tableloading,
            ifselection: false,
            isPagination: true,
            isIndex: true,
            tableData: _ctx.seeTable.tableData,
            tableColumn: _ctx.seeTable.tableColumn,
            pageSize: _ctx.seeTable.selectData.pageSize,
            total: _ctx.seeTable.tableData.length,
            currentPage: _ctx.seeTable.selectData.pageNum,
            onHandleCurrentChange: _ctx.seeTable.seeHandleCurrentChange
          }, {
            cardNum: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "开卡客户",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  (row.cardNum > 0)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.routerOrder(row)),
                        class: "blue_type"
                      }, _toDisplayString(row.cardNum), 9, _hoisted_13))
                    : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(row.cardNum), 1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["isLoading", "tableData", "tableColumn", "pageSize", "total", "currentPage", "onHandleCurrentChange"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}